import React, { useEffect, useState } from "react";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import CustomReactQuillDescription from "../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import { useDispatch, useSelector } from "react-redux";
import { getPortfoliobyId } from "../../../redux/profile/action";
import { useParams } from "react-router-dom";
import ReactImageGalleryCompoment from "../FindWork/SearchContestParticipate/ContestDetails/ReactImageGalleryCompoment";

export default function ManagePortfoliodetails() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [images, setImages] = useState([]);

  useEffect(() => {
    if (id) {
      dispatch(getPortfoliobyId(id));
    }
  }, [id]);

  const porpoliobyid = useSelector(
    ({ profile: { porpoliobyid } }) => porpoliobyid
  );

  useEffect(() => {
    if (porpoliobyid && Array.isArray(porpoliobyid.files)) {
      const imageArray = porpoliobyid.files.map((file) => ({
        original: file.file,
        thumbnail: file.file,
      }));
      setImages(imageArray);
    }
  }, [porpoliobyid]);

  return (
    <div className="workdetail">
      <div className="col-lg-10 mx-auto">
        <div className="website-musai">
          <h2 className="pb-3">{porpoliobyid?.title}</h2>
        </div>
        <div className="col-md-12">
          <ReactImageGalleryCompoment images={images} />
        </div>
        {
          porpoliobyid?.description &&
          <>
            <h6>Project Description</h6>
            <CustomReactQuillDescription value={porpoliobyid?.description} />
          </>
        }

        {(Array?.isArray(porpoliobyid?.skills) && porpoliobyid?.skills?.length > 0) && (
          <>
            <h6>Competencies</h6>
            <div className="add-skills py-3">
              {Array?.isArray(porpoliobyid?.skills) &&
                porpoliobyid?.skills?.map((item, index) => (
                  <div key={index}>
                    <p>{item?.title}</p>
                  </div>
                ))}
            </div>
          </>
        )}
        {porpoliobyid?.url &&
          <h6>
            <h6>Project URL :</h6> {" "}
            <a
              href={
                porpoliobyid?.url?.startsWith("http")
                  ? porpoliobyid?.url
                  : `https://${porpoliobyid?.url}`
              }
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "blue", textDecoration: "none" }}
            >
              {porpoliobyid?.url}
            </a>
          </h6>
        }
      </div>
    </div>
  );
}